
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_wih1l_meizq_13",
  "tools": "awsui_tools_wih1l_meizq_24",
  "tools-filtering": "awsui_tools-filtering_wih1l_meizq_33",
  "tools-align-right": "awsui_tools-align-right_wih1l_meizq_46",
  "tools-clear-sort": "awsui_tools-clear-sort_wih1l_meizq_50",
  "tools-pagination": "awsui_tools-pagination_wih1l_meizq_53",
  "tools-preferences": "awsui_tools-preferences_wih1l_meizq_53",
  "tools-small": "awsui_tools-small_wih1l_meizq_59",
  "table": "awsui_table_wih1l_meizq_63",
  "table-layout-fixed": "awsui_table-layout-fixed_wih1l_meizq_70",
  "wrapper": "awsui_wrapper_wih1l_meizq_74",
  "variant-stacked": "awsui_variant-stacked_wih1l_meizq_81",
  "wrapper-content-measure": "awsui_wrapper-content-measure_wih1l_meizq_81",
  "variant-container": "awsui_variant-container_wih1l_meizq_81",
  "has-footer": "awsui_has-footer_wih1l_meizq_84",
  "has-header": "awsui_has-header_wih1l_meizq_87",
  "cell-merged": "awsui_cell-merged_wih1l_meizq_104",
  "cell-merged-content": "awsui_cell-merged-content_wih1l_meizq_116",
  "empty": "awsui_empty_wih1l_meizq_132",
  "loading": "awsui_loading_wih1l_meizq_136",
  "selection-control": "awsui_selection-control_wih1l_meizq_145",
  "selection-control-header": "awsui_selection-control-header_wih1l_meizq_152",
  "selection-control-content-spans-rows": "awsui_selection-control-content-spans-rows_wih1l_meizq_157",
  "header-secondary": "awsui_header-secondary_wih1l_meizq_164",
  "variant-full-page": "awsui_variant-full-page_wih1l_meizq_175",
  "table-has-header": "awsui_table-has-header_wih1l_meizq_181",
  "header-controls": "awsui_header-controls_wih1l_meizq_192",
  "variant-embedded": "awsui_variant-embedded_wih1l_meizq_204",
  "variant-borderless": "awsui_variant-borderless_wih1l_meizq_204",
  "footer-wrapper": "awsui_footer-wrapper_wih1l_meizq_209",
  "footer": "awsui_footer_wih1l_meizq_209",
  "footer-with-pagination": "awsui_footer-with-pagination_wih1l_meizq_217",
  "footer-pagination": "awsui_footer-pagination_wih1l_meizq_225",
  "thead-active": "awsui_thead-active_wih1l_meizq_229",
  "row": "awsui_row_wih1l_meizq_230",
  "row-selected": "awsui_row-selected_wih1l_meizq_231",
  "skeleton-loading-cell": "awsui_skeleton-loading-cell_wih1l_meizq_235"
};
  